import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { useUiStore } from './store/uiStore'
import { useEffect } from 'react'

export default function App() {
  const darkMode = useUiStore((s) => s.darkMode)

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [darkMode])

  return <RouterProvider router={router} />
}
